module.exports = __webpack_public_path__ + "media/customizations/crystallake/logo-new-c0f5fc3ee73653711dbaad6ca36d42aa.png";